import { Heading1 } from '@sb1/ffe-core-react';
import styles from './payment-compact-info-card-container.module.less';
import I18nText from '../../i18n/I18nText';
import { PAYMENT_TEXT_KEY } from '../../i18n/project-i18n-model';
import { PaymentCompactInfoCard } from '../payment-compact-info-card/PaymentCompactInfoCard';

const Wave = ({ color, className }) => {
    return (
        <svg
            width="1440"
            height="250"
            viewBox="0 0 1440 250"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g clipPath="url(#clip0_1253_172036)">
                <g clipPath="url(#clip1_1253_172036)">
                    <mask
                        id="mask0_1253_172036"
                        style={{ maskType: 'alpha' }}
                        maskUnits="userSpaceOnUse"
                        x="-493"
                        y="-1"
                        width="6303"
                        height="1741"
                    >
                        <path
                            d="M-493 1739.55L-493 0.000244141C-293.316 0.000226684 -191.664 45.2942 -93.6313 88.947C6.37539 133.585 100.79 175.596 294.881 175.596C488.973 175.596 583.388 133.584 683.394 88.9469C781.427 45.2941 882.75 0.000123869 1082.43 0.000106412C1282.12 8.89549e-05 1383.77 45.294 1481.8 88.9469C1581.81 133.584 1676.22 175.596 1870.32 175.596C2064.41 175.596 2158.82 133.584 2258.83 88.9468C2356.86 45.2939 2458.18 -1.386e-05 2657.87 -3.1317e-05C2857.55 -4.87739e-05 2959.2 45.2939 3057.24 88.9467C3157.24 133.584 3251.66 175.596 3445.75 175.596C3639.84 175.596 3734.26 133.584 3834.26 88.9467C3932.29 45.2938 4033.62 -0.000151589 4233.3 -0.000169046C4432.99 -0.000186503 4534.64 45.2937 4632.67 88.9466C4732.68 133.584 4827.09 175.596 5021.18 175.596C5215.27 175.596 5309.69 133.584 5409.7 88.9465C5507.73 45.2937 5609.05 -0.000289318 5809.06 -0.000306803L5809.06 1739.55"
                            fill="black"
                        />
                    </mask>
                    <g mask="url(#mask0_1253_172036)">
                        <rect x="-493" y="0.000244141" width="2767" height="196.93" fill={color} />
                    </g>
                </g>
                <rect x="-493" y="193.648" width="2767" height="275.352" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_1253_172036">
                    <rect width="2767" height="1169" fill="white" transform="translate(-493 0.000244141)" />
                </clipPath>
                <clipPath id="clip1_1253_172036">
                    <rect width="2767" height="196.93" fill="white" transform="translate(-493 0.000244141)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const PaymentCompactInfoCardContainer = ({ project, subproject, dismissSupport, headingText }) => {
    return (
        <div className={styles.container}>
            <div className={[styles.background, 'ffe-accent-mode'].join(' ')}>
                <div className={styles.backgroundColor} />
                <Wave color={'#084F91'} className={styles.wave} />
            </div>
            <div className={styles.content}>
                <Heading1 className={styles.title}>{headingText}</Heading1>
                <div className={styles.cardContainer}>
                    <PaymentCompactInfoCard project={project} subproject={subproject} dismissSupport={dismissSupport} />
                </div>
            </div>
        </div>
    );
};
